<template>
    <div>
        <node
            v-if="rootNode"
            :node="rootNode"
            :app="app"
        />
        <router-link to="/demo" id="demo"></router-link>
        <router-link to="/upload" id="upload"></router-link>
        <router-link to="/s3" id="s3"></router-link>
    </div>
</template>

<script>
import Vue     from 'vue';
import Node    from '../node/component.vue';
import parse   from '../org-parser';
import welcome from './welcome.org';

export default {
    props: ['app'],

    components: {
        Node
    },

    data() {
        return {
            file: undefined,
            dragging: false
        };
    },

    beforeMount() {
        var _ = this;

        if (_.app.file) {
            _.$router.push('/read');
        } else if (_.app.config && _.app.config.type) {
            _.app.setConfig(_.app.config, true);
        } else {
            _.welcome();
        }
    },

    computed: {
        rootNode() {
            if (!this.file) return;

            var _ = this,
                root = new Vue({ data: {
                    type: 'root',
                    children: parse(_.file),
                    isExpanded: true
                }});

            _.app.expandNode(root);

            return root;
        }
    },

    methods: {
        welcome() {
            var _ = this;

            _.file = welcome;
            _.app.expandChildren(_.rootNode, true);
        }
    }
};
</script>
